//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { claimReportApplyQuery } from '@/api/rinko';
import { getChilComList, getProductList, getCompanyList } from '@/api/baseDate';
export default {
  name: 'ClaimReportApply',
  data: function data() {
    return {
      currentPage4: 4,
      loading: false,
      restaurants: [],
      timeout: null,
      tableData: [],
      options: [{
        value: '666666',
        label: '人民保险'
      }],
      options1: [{
        value: '1',
        label: '上海分公司'
      }],
      options2: [{
        value: '1',
        label: '人身意外伤害保险'
      }, {
        value: '2',
        label: '出口产品责任保险'
      }, {
        value: '3',
        label: '关税保证保险'
      }, {
        value: '4',
        label: '货物运输保险'
      }, {
        value: '5',
        label: '企业财产保险'
      }, {
        value: '6',
        label: '安全生产责任保险'
      }, {
        value: '7',
        label: '出口贸易信用保险（短期）'
      }],
      options3: [{
        value: '1',
        label: '是'
      }],
      options4: [{
        value: '0',
        label: '新建'
      }, {
        value: '1',
        label: '待补录'
      }, {
        value: '2',
        label: '暂存'
      }, {
        value: '3',
        label: '自核失败'
      }, {
        value: '4',
        label: '自核通过提交核保'
      }, {
        value: '5',
        label: '核保失败'
      }, {
        value: '6',
        label: '核保成功'
      }, {
        value: '7',
        label: '已申报'
      }],
      inForm: {
        companyCode: '',
        customsListNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        insuredName: '',
        policyNo: '',
        protocolNo: '',
        productCode: '',
        productName: '',
        startDateEnd: '',
        startDateStart: '',
        damageDate: ''
      },
      pageNo: 1,
      // 第几页
      pageSize: 10,
      // 每页数量
      total: 0,
      // 总条数
      rules: {
        insuranceCompanyCode: [{
          required: true,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        companyCode: [{
          required: false,
          message: '请选择分支机构',
          trigger: 'change'
        }],
        productCode: [{
          required: false,
          message: '请选择产品名称',
          trigger: 'change'
        }],
        addRecordFlag: [{
          required: false,
          message: '请选择自动申报补录',
          trigger: 'change'
        }],
        proposalStatus: [{
          required: false,
          message: '请选择保单状态',
          trigger: 'change'
        }]
      },
      options_insuranceCompanyName: [{
        value: 'IC0030',
        label: '中国太平洋财产保险股份有限公司上海分公司'
      }],
      options_companyName: []
    };
  },
  created: function created() {
    debugger; // const list = this.$store.state.user.userinfo.insuranceCompanyList || []
    // // const companyCode = this.$store.state.user.userinfo.insuranceCompanyCode || ""
    // console.log(this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode, 'this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode')
    // if (list.length > 0) {
    //   const companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || ''
    //   this.get_select(list, companyCode)
    // 默认第一个保险公司

    this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value || '';
    this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label || ''; // }

    this.restaurants = this.loadAll();
    debugger;
    this.Init_get();
  },
  mounted: function mounted() {
    this.search_s('inForm'); // this.riskqueryAll_fun(this.inForm.insuranceCompanyCode)
  },
  methods: {
    // 初始化
    Init_get: function Init_get() {
      var _this = this;

      debugger; // 去除查询条件前后空格

      if (this.inForm.policyNo !== null && this.inForm.policyNo !== undefined && this.inForm.policyNo !== '') {
        this.inForm.policyNo = this.inForm.policyNo.replace(/(^\s*)|(\s*$)/g, '');
      }

      if (this.inForm.protocolNo !== null && this.inForm.protocolNo !== undefined && this.inForm.protocolNo !== '') {
        this.inForm.protocolNo = this.inForm.protocolNo.replace(/(^\s*)|(\s*$)/g, '');
      }

      if (this.inForm.customsListNo !== null && this.inForm.customsListNo !== undefined && this.inForm.customsListNo !== '') {
        this.inForm.customsListNo = this.inForm.customsListNo.replace(/(^\s*)|(\s*$)/g, '');
      }

      var data = this.inForm;
      this.loading = true;
      data.pageNo = this.pageNo;
      data.pageSize = this.pageSize;
      claimReportApplyQuery(data).then(function (res) {
        var orgCode = JSON.parse(sessionStorage.getItem('neworgCode'));
        console.log(orgCode, '信用代码');
        console.log(res.content);

        if (res.content != null) {
          for (var i = 0; i < res.content.length; i++) {
            if (orgCode != null && orgCode != '') {
              res.content[i].user_type = '0';
            } else {
              res.content[i].user_type = '1';
            }

            if (res.content[i].claimStatus != null) {
              if (res.content[i].claimStatus === '0') {
                res.content[i].claimStatus = '暂存';
              } else {
                res.content[i].claimStatus = '已提交';
              }
            }
          }
        }

        _this.tableData = res.content || [];
        _this.total = res.totalCount;
        _this.loading = false;
      });
    },
    // 保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label;
      this.companyqueryAll_fun(val); // this.riskqueryAll_fun(val)
    },
    // 分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.companyName = obj.label;
    },
    // 产品名称 --险种
    productCode_ch: function productCode_ch(val) {
      var obj = {};
      obj = this.options2.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据l
      });
      this.inForm.productName = obj.label;
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    // 当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    // 查询
    search_s: function search_s(formName) {
      var _this2 = this;

      this.pageNo = 1;
      this.pageSize = 10;

      if (this.inForm.startDateEnd && this.inForm.startDateStart) {
        if (this.getTimes(this.inForm.startDateStart) > this.getTimes(this.inForm.startDateEnd)) {
          this.$message({
            message: '录入起保时间的起期不能晚于起保时间止期',
            type: 'warning'
          });
          return;
        }
      } else if (this.inForm.startDateEnd && !this.inForm.startDateStart) {
        this.$message({
          message: '请录入起保时间起期',
          type: 'warning'
        });
        return;
      } else if (!this.inForm.startDateEnd && this.inForm.startDateStart) {
        this.$message({
          message: '请录入起保时间止期',
          type: 'warning'
        });
        return;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.Init_get();
        } else {
          return false;
        }
      });
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      // console.log(this.ruleForm.businessStartDate)
      var date = time;
      date = date.substring(0, 19);
      date = date.replace(/-/g, '/'); // 必须把日期'-'转为'/'

      var timestamp = new Date(date).getTime();
      return timestamp;
    },
    // 重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        proposalNo: '',
        insuranceCompanyCode: this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode,
        insuranceCompanyName: '',
        companyCode: '',
        companyName: '',
        productCode: '',
        productName: '',
        startDateStart: '',
        startDateEnd: '',
        insuredName: '',
        addRecordFlag: '',
        proposalStatus: '',
        protocolNo: '',
        customsListNo: ''
      };
      this.insuranceCompanyCode_ch(this.inForm.insuranceCompanyCode);
    },
    // 支持模糊查询
    loadAll: function loadAll() {
      return [{
        'value': '三全鲜食（北新泾店）',
        'address': '长宁区新渔路144号'
      }, {
        'value': 'Hot honey 首尔炸鸡（仙霞路）',
        'address': '上海市长宁区淞虹路661号'
      }, {
        'value': '新旺角茶餐厅',
        'address': '上海市普陀区真北路988号创邑金沙谷6号楼113'
      }];
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {},
    // 查看 ------ 编辑
    view_but: function view_but(type, row) {
      var params = {
        policyNo: row.row.policyNo,
        type: type,
        flag: 'claim',
        claimCode: 'claim'
      };
      this.$router.push({
        path: "/rinkoPlatClaimReport/claimApply/".concat(params.policyNo, "/").concat(params.type, "/").concat(params.flag, "/").concat(params.claimCode)
      });
    },
    view_but2: function view_but2(type, row) {
      var params = {
        type: type,
        policyNo: row.row.policyNo
      }; // console.log(params.insurancecompanyCode)

      this.$router.push({
        path: "/rinkoPlatClaimReport/claimPolicyInfoBuLu/".concat(params.policyNo, "/").concat(params.type)
      });
    },
    // ------下拉信息
    get_select: function get_select(list, code) {
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code);
    },
    // 保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};

        if (list) {
          obj.value = list[i].insuranceCompanyCode || '';
          obj.label = list[i].insuranceCompanyName || '';
          this.options_insuranceCompanyName.push(obj);
        }
      }
    },
    // 分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this3 = this;

      var data = {
        insuranceCompanyCode: code || ''
      };
      getChilComList(data).then(function (res) {
        _this3.options_companyName = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this3.options_companyName.push(obj);
        }
      });
    },
    // 产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this4 = this;

      var data = {
        insuranceCompanyCode: code || ''
      };
      getProductList(data).then(function (res) {
        _this4.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].productCode;
          obj.label = res[i].productName;

          _this4.options2.push(obj);
        }
      });
    },
    claimApply: function claimApply(scopeData) {
      var data = {
        'policyNo': 'qeqweqeq123',
        'type': 'add'
      };
      console.log(scopeData);
      this.$router.push({
        path: "/rinkoPlatClaimReport/claimApply/".concat(data.policyNo, "/").concat(data.type)
      });
    }
  }
};